import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const ForYouSection: React.FC = () => {
  const points = ['Sabés teoría, pero querés más estructura práctica.', 'A veces terminás una sesión sin saber bien cómo seguir la próxima.', 'Sentís que algunas sesiones dependen demasiado del momento.', 'Querés trabajar con más seguridad y menos desgaste mental.', 'Buscás herramientas reales, no más contenido abstracto.'];
  return <section className="py-12 md:py-20 px-4 bg-navy-800" data-id="element-35">
      <div className="max-w-md md:max-w-3xl mx-auto bg-navy-900 rounded-2xl md:rounded-3xl p-6 md:p-12 border border-navy-700 shadow-2xl" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-37">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 md:mb-8 text-center text-white" data-id="element-38">
            ESTE KIT ES PARA VOS SI...
          </h2>

          <ul className="space-y-4 md:space-y-5" data-id="element-39">
            {points.map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-start gap-3 md:gap-4" data-id="element-40">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-gold-500 shrink-0 mt-0.5" data-id="element-41" />
                <span className="text-base md:text-lg text-gray-200" data-id="element-42">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
};